module.exports = __webpack_public_path__ + "assets/img/00039.da56faed.png";